import(/* webpackMode: "eager" */ "/srv/panel/app/global-error.tsx");
